import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';
import InputIcon from 'react-multi-date-picker/components/input_icon';
import DatePicker from 'react-multi-date-picker';

import 'react-multi-date-picker/styles/backgrounds/bg-dark.css';

import ErrorMessage from '../../Shared/Components/ErrorMessage';
import FileUploader from '../../Shared/Components/FileUploader';
import { getStoredAuthToken } from '../../Shared/utils/authToken';
import { baseApiUrl } from '../../Shared/utils/helper';

const UserProfileFormFields = ({
  values,
  errors,
  handleChange,
  setFieldValue,
  provinces,
  photoIds,
  setPhotoIds,
}) => (
  <div className='row border rounded p-2 mt-2'>
    <div className='col-12 col-md-6'>
      <div className='form-group'>
        <label>نام</label>
        <input
          name='first_name'
          value={values.first_name}
          onChange={handleChange}
          className='form-control'
        />
        <ErrorMessage error={errors.first_name} />
      </div>
    </div>
    <div className='col-12 col-md-6'>
      <div className='form-group'>
        <label>نام خانوادگی</label>
        <input
          name='last_name'
          value={values.last_name}
          onChange={handleChange}
          className='form-control'
        />
        <ErrorMessage error={errors.last_name} />
      </div>
    </div>
    <div className='col-12 col-md-6'>
      <div className='form-group'>
        <label>نام پدر</label>
        <input
          name='father_name'
          value={values.father_name}
          onChange={handleChange}
          className='form-control'
        />
        <ErrorMessage error={errors.father_name} />
      </div>
    </div>
    <div className='col-12 col-md-6'>
      <div className='form-group'>
        <label>کد ملی</label>
        <input
          name='nat_code'
          value={values.nat_code}
          readOnly
          className='form-control bg-light'
        />
      </div>
    </div>
    <div className='col-12 col-md-6'>
      <div className='form-group'>
        <label>موبایل</label>
        <input
          name='mobile'
          value={values.mobile}
          onChange={handleChange}
          className='form-control dir-ltr text-left'
        />
        <ErrorMessage error={errors.mobile} />
      </div>
    </div>
    <div className='col-12 col-md-6'>
      <div className='form-group'>
        <label>تلفن ثابت</label>
        <input
          name='phone'
          value={values.phone}
          onChange={handleChange}
          className='form-control dir-ltr text-left'
        />
        <ErrorMessage error={errors.phone} />
      </div>
    </div>
    <div className='col-12 col-md-6'>
      <div className='form-group'>
        <label>جنسیت</label>
        <select
          name='gender'
          value={values.gender}
          onChange={handleChange}
          className='form-control'
        >
          <option value=''>انتخاب کنید</option>
          <option value={1}>مرد</option>
          <option value={0}>زن</option>
        </select>
        <ErrorMessage error={errors.gender} />
      </div>
    </div>
    <div className='col-12 col-md-6'>
      <div className='form-group'>
        <label>استان</label>
        <select
          name='province_id'
          value={values.province_id}
          onChange={handleChange}
          className='form-control'
        >
          <option value=''>انتخاب کنید</option>
          {provinces?.map((item) => (
            <option key={item.id} value={item.id}>
              {item.name}
            </option>
          ))}
        </select>
        <ErrorMessage error={errors.province_id} />
      </div>
    </div>
    <div className='col-12 col-md-6'>
      <div className='form-group'>
        <label>شهر</label>
        <input
          name='city'
          value={values.city}
          onChange={handleChange}
          className='form-control'
        />
        <ErrorMessage error={errors.city} />
      </div>
    </div>
    <div className='col-12 col-md-6'>
      <div className='form-group'>
        <label>تاریخ تولد</label>
        <DatePicker
          render={<InputIcon />}
          calendar={persian}
          locale={persian_fa}
          value={
            values.birth_date === undefined || values.birth_date == null
              ? ''
              : values.birth_date
          }
          minDate={new Date().setFullYear(1921)}
          portal
          zIndex='9999999999999'
          format='YYYY/M/D'
          onChange={(date) => {
            if (!date) {
              setFieldValue('birth_date', '');
              return;
            }
            setFieldValue(
              'birth_date',
              `${date.year}/${date.month}/${date.day}`,
            );
          }}
        />
        <ErrorMessage error={errors.birth_date} />
      </div>
    </div>
    <div className='col-12 col-md-6'>
      <div className='form-group'>
        <label>کلمه عبور جدید (اختیاری)</label>
        <input
          name='password'
          type='password'
          value={values.password}
          onChange={handleChange}
          className='form-control'
          autoComplete='new-password'
        />
        <ErrorMessage error={errors.password} />
      </div>
    </div>
    <div className='col-12 col-md-6'>
      <div className='form-group'>
        <label>تکرار کلمه عبور</label>
        <input
          name='password_confirmation'
          type='password'
          value={values.password_confirmation}
          onChange={handleChange}
          className='form-control'
          autoComplete='new-password'
        />
        <ErrorMessage error={errors.password_confirmation} />
      </div>
    </div>
    <div className='col-12 col-md-6'>
      <div className='form-group'>
        <label>تصویر پروفایل</label>
        {values.avatar ? (
          <img
            src={values.avatar}
            alt='avatar'
            className='my-2 rounded-circle img-thumbnail d-block'
            style={{ width: '80px', height: '80px' }}
          />
        ) : null}
        <FileUploader
          files={photoIds}
          setFiles={setPhotoIds}
          roles={['image/jpeg', 'image/jpg', 'image/png']}
          allowMultiple={false}
          maxFiles={1}
          maxFileSize='1024KB'
          serverUrl={`${baseApiUrl()}/user/image-upload?folder=users/avatar`}
          method='POST'
          headers={{
            Accept: 'application/json',
            Authorization: getStoredAuthToken()
              ? `Bearer ${getStoredAuthToken()}`
              : '',
          }}
        />
      </div>
    </div>
  </div>
);

export default UserProfileFormFields;
